import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // Активная страница в приложении
    active_page: 1,
    // Токен для авторизации
    token: null
  },
  mutations: {
    change_active_page(state, id) {
      state.active_page = id;
    },
    set_token(state, token) {
      state.token = token;
    }
  },
  actions: {},
  plugins: [createPersistedState()]
});
